import { render, staticRenderFns } from "./dept-kv.vue?vue&type=template&id=500ceb34&"
import script from "./dept-kv.vue?vue&type=script&lang=js&"
export * from "./dept-kv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports